import { withFullStoryExclude } from "../../../utils/fullStoryHelper";

const columns = [
    {
        Header: "reportingCombinationsHistoryLines_Nr",
        Accessor: "Nr",
        Filterable: false,
    },
    {
        Header: "reportingCombinationsHistoryLines_ID",
        Accessor: "ID",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_StartingDate",
        Accessor: "Starting Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_DeletionDate",
        Accessor: "Deletion Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ReportingCombinationID",
        Accessor: "Reporting Combination ID",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_Username",
        Accessor: "User Name",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ReporterId",
        Accessor: "Reporter ID",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_UserCode",
        Accessor: "User Code",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_VATCode",
        Accessor: "VAT Code",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_CountryAsString",
        Accessor: "Country",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_VATRate",
        Accessor: "VAT Rate",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_VATRateType",
        Accessor: "VAT Rate Type",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_CombinationIDInvoice",
        Accessor: "Combination ID Invoice",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_CombinationIDCredit",
        Accessor: "Combination ID Credit",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_IntrastatIn",
        Accessor: "Intrastat In",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_IntrastatOut",
        Accessor: "Intrastat Out",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_ECListing",
        Accessor: "EC Listing",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_DeductibleVAT",
        Accessor: "Deductible VAT",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_GoodType",
        Accessor: "Good Type",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_MainVATCode",
        Accessor: "Main VAT Code",
        Filterable: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "reportingCombinationsHistoryLines_LineFlowType",
        Accessor: "Line Flow Type",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_iVATTransactionID",
        Accessor: "VAT Reporting Transaction ID",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_StartDate",
        Accessor: "Start Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_EndDate",
        Accessor: "End Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_itemType",
        Accessor: "Item Type",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_VATCodeFlow",
        Accessor: "VAT Code Flow",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ExtraReports",
        Accessor: "Extra Reports",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_RevisionVATCodeTaxBConvertedToVAT",
        Accessor: "Revision VAT Code",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_FixedAsset",
        Accessor: "Fixed Asset",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_RefundVATCode",
        Accessor: "Refund VAT Code",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_RefundType",
        Accessor: "Refund Type",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_VATCodeForVATUnit",
        Accessor: "VAT Code For VAT Unit",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ProRata",
        Accessor: "ProRata",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_RecalculateVAT",
        Accessor: "Recalculate VAT",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_DateUsedForReporting",
        Accessor: "Date Used For Reporting",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ExtraDescription",
        Accessor: "Extra Description",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ReverseChargeDocument",
        Accessor: "Reverse Charge Document",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_MOSS",
        Accessor: "MOSS",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_WithholdingRate",
        Accessor: "Withholding Rate",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ExtraTaxbBoxes",
        Accessor: "Extra Taxb Boxes",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_ExtraVATBoxes",
        Accessor: "Extra VAT Boxes",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_extraTaxbBoxesCredit",
        Accessor: "Extra Taxb Boxes Credit",
        Filterable: true,
    },
    {
        Header: "reportingCombinationsHistoryLines_extraVATBoxesCredit",
        Accessor: "Extra VAT Boxes Credit",
        Filterable: true,
    },
];

export default columns;
